module.exports = __webpack_public_path__ + "img/toplogo.a74048de.png";